import { win } from './win';

export const perfNow = (): number =>
  win?.performance?.now ? win.performance.now() : Date.now();
